import { DeleteFristenDialog } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/DeleteFristenDialog/DeleteFristenDialog';
import { FristenMobile } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/FristenMobile/FristenMobile';
import { FristenSuggestions } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/FristenSuggestions';
import { FristenTable } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/FristenTable/FristenTable';
import { CreateSheet } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/Sheet/CreateSheet';
import { EditSheet } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/Sheet/EditSheet';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Body, Heading } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function Fristen() {
  const { ctx } = useAnlageassistentContext();
  const { t } = useTranslation();
  return (
    <>
      <div className=" flex flex-col gap-8">
        <div className="flex flex-col gap-6 items-start">
          <div className="flex flex-col gap-3">
            <Heading>{ctx.getCurrentSubStep()?.title}</Heading>
            <Body>
              {t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.description',
              )}
            </Body>
          </div>
          <FristenTable />
          <FristenMobile />
          <FristenSuggestions />
          <CreateSheet />
        </div>
      </div>
      <EditSheet />
      <DeleteFristenDialog />
    </>
  );
}
